import { defineSlotRecipe } from '@chakra-ui/react';
import { accordionAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: accordionAnatomy.keys(),
  base: {
    itemTrigger: {
      cursor: 'pointer',
      borderRadius: 'none',
      fontWeight: 'normal',
      _hover: {
        bg: 'inherit',
      },
    },
    itemIndicator: {
      boxSize: 7,
      color: 'primary.solid',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    itemBody: {
      pt: 2,
      pb: 5,
      px: 4,
    },
  },
});
